import type { OutgoingChatMessage } from './chatTransport';

import { sendNewMessageV2 } from '@/services/sendNewMessageV2';
import type { MessageData } from '@/types/messageData';

/** Posts a viewer's message into a conversation. Throws the API's error. */
export type PostChatMessage = (
  conversationId: string,
  message: OutgoingChatMessage
) => Promise<void>;

/**
 * Sends through the inquiry messages endpoint, which every transport uses
 * today: the API writes the message to Twilio and the stored copy reaches
 * the chat as any other message does. It returns no message, so the send
 * resolves with nothing. The endpoint does not deduplicate on the id yet.
 */
export const postInquiryMessage: PostChatMessage = async (conversationId, message) => {
  await sendNewMessageV2({
    conversationId,
    clientMessageId: message.clientMessageId,
    message: message.body,
    files: message.files ? [...message.files] : [],
    ...(message.data ? { data: message.data as MessageData } : {}),
    ...(message.replyDraftId ? { replyDraftId: message.replyDraftId } : {}),
  });
};
